import React from "react";
import "./Footop.css";
import downImg from "../../assets/imgs/downImg.png"; 
import footImg from "../../assets/imgs/footImg.jpg"; 

export default function Footop() {
  const handleDownload = () => {
    window.open("/brochure.pdf", "_blank");
  };

  const handleVideo = () => {
    window.open("https://www.youtube.com/watch?v=XXXXXX", "_blank");
  };

  return (
    <div className="footp">
      <div className="maxW">
        <div className="footmn">

          <div className="ftLeft">
            <h2>
              Download Full Details, Floor Plans,<br />
              Specifications, Price etc.
            </h2>

            <button onClick={handleDownload}>
              Download Brochure <img src={downImg} alt="download" />
            </button>
          </div>


          <div className="ftRight" onClick={handleVideo}>
            <img src={footImg} alt="project" />
     
          </div>

        </div>
      </div>
    </div>
  );
}
